import { faqs, testimonials } from "@/mocks/home";

export default function FaqAboutSection() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        {/* FAQ */}
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            <i className="ri-question-line"></i>吃瓜问答
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            关于实时更新，你关心的
          </h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            有关最新瓜料、消息可信度与投稿的常见疑问，在这里一次说清。
          </p>
          <dl className="mt-6 divide-y divide-background-200 border-y border-background-200">
            {faqs.map((f) => (
              <details key={f.q} className="group py-4">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3">
                  <span className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                  <i className="ri-add-line shrink-0 text-lg text-primary-500 transition group-open:rotate-45"></i>
                </summary>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              </details>
            ))}
          </dl>
        </div>

        {/* 口碑与关于 */}
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-heart-3-line"></i>吃瓜口碑
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            大家都在这样刷
          </h2>
          <div className="mt-6 space-y-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-base font-black text-background-50">
                      {t.name.slice(0, 1)}
                    </span>
                    <div>
                      <figcaption className="text-sm font-bold text-foreground-950">{t.name}</figcaption>
                      <span className="text-xs text-foreground-500">{t.role}</span>
                    </div>
                  </div>
                  <span className="flex items-center gap-0.5 text-accent-500" aria-label={`${t.star} 星评价`}>
                    {Array.from({ length: t.star }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </span>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
              </figure>
            ))}
          </div>

          <div className="mt-6 rounded-xl bg-primary-500 p-6 text-background-50">
            <h3 className="font-heading text-lg font-black text-background-50">今天吃瓜，是什么？</h3>
            <p className="mt-2 text-sm leading-relaxed text-primary-100">
              我们是一支专注实时资讯与热门话题甄别的编辑部，聚焦娱乐八卦、剧集综艺、音乐与时尚风向。坚持信息透明、来源可溯、动态持续跟进——让你吃到的每一口瓜，都有据可查、追得到底。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}